export enum EWhatsAppTransportType {
  DesktopAgent = 0,
  WhatsAppSaaS = 1,
}
